var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (Date, comments, i18n, isEmoji, isNoMoreComments, moment, peerAuthoring, undefined) {
if ( comments.length === 0)
{
buf.push("<p id=\"social-view-no-comments\" class=\"block-h-lg text-lg text-center\">" + (jade.escape(null == (jade_interp = i18n("social.be-first")) ? "" : jade_interp)) + "</p>");
}
else
{
var d1, d2, distance = 1000 * 60 * 5;
buf.push("<ul class=\"clearfix\">");
// iterate comments 
;(function(){
  var $$obj = comments ;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var comment = $$obj[i];

d2 = new Date(comment.timestamp)
if ( !d1 || moment(d1).diff(d2) > distance)
{
d1 = d2;
buf.push("<li class=\"time text-center text-sm\"><strong>" + (jade.escape(null == (jade_interp = moment(comment.timestamp).format("ddd, DD MMM")) ? "" : jade_interp)) + "</strong>" + (jade.escape(null == (jade_interp = moment(comment.timestamp).format(" h:mm")) ? "" : jade_interp)) + "</li>");
}
buf.push("<li" + (jade.attr("style", i < 5 ? "transition-delay: " + ((i + 1) * 100) + "ms" : "", true, false)) + (jade.cls(['comment',[
          comment.isFromCurrentLearner ? "pull-right is-learner" : "pull-left",
          comment.likes > 0 ? "has-likes" : "no-likes",
          comment.isLikedByLearner ? "is-learner-liked" : "",
          comment.isFlaggedByLearner ? "is-learner-flagged" : ""
        ]], [null,true])) + "><div class=\"comment-label clearfix\">");
if ( !comment.isFromCurrentLearner)
{
buf.push("<span class=\"comment-author\">" + (jade.escape(null == (jade_interp = comment.author) ? "" : jade_interp)) + "</span>&ensp;");
}
if ( !peerAuthoring)
{
buf.push("<span" + (jade.attr("data-id", comment.id, true, false)) + " class=\"comment-action comment-like\"><span class=\"icon icon-heart\"></span>&nbsp;" + (jade.escape((jade_interp = comment.likes || 0) == null ? '' : jade_interp)) + "</span>");
}
buf.push("</div>");
if ( !peerAuthoring)
{
buf.push("<div class=\"comment-toggle-action clearfix\">");
if ( comment.isFromCurrentLearner)
{
buf.push("<span" + (jade.attr("data-id", comment.id, true, false)) + " class=\"comment-action comment-delete\">" + (jade.escape(null == (jade_interp = i18n("social.delete")) ? "" : jade_interp)) + "</span><span class=\"comment-action comment-cancel icon icon-close\"></span>");
}
else
{
buf.push("<span" + (jade.attr("data-id", comment.id, true, false)) + " class=\"comment-action comment-flag\"><span class=\"icon icon-flag\"></span>&nbsp;");
if ( comment.isFlaggedByLearner)
{
buf.push(jade.escape(null == (jade_interp = i18n("social.reported")) ? "" : jade_interp));
}
else
{
buf.push(jade.escape(null == (jade_interp = i18n("social.report")) ? "" : jade_interp));
}
buf.push("</span><span class=\"comment-action comment-cancel icon icon-close\"></span>");
}
buf.push("</div>");
}
buf.push("<p class=\"block-md comment-message text-md\">");
if ( isEmoji(comment.message))
{
buf.push("<span class=\"emoji\">" + (jade.escape(null == (jade_interp = comment.message) ? "" : jade_interp)) + "</span>");
}
else
{
buf.push(jade.escape(null == (jade_interp = comment.message) ? "" : jade_interp));
}
buf.push("</p></li>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var comment = $$obj[i];

d2 = new Date(comment.timestamp)
if ( !d1 || moment(d1).diff(d2) > distance)
{
d1 = d2;
buf.push("<li class=\"time text-center text-sm\"><strong>" + (jade.escape(null == (jade_interp = moment(comment.timestamp).format("ddd, DD MMM")) ? "" : jade_interp)) + "</strong>" + (jade.escape(null == (jade_interp = moment(comment.timestamp).format(" h:mm")) ? "" : jade_interp)) + "</li>");
}
buf.push("<li" + (jade.attr("style", i < 5 ? "transition-delay: " + ((i + 1) * 100) + "ms" : "", true, false)) + (jade.cls(['comment',[
          comment.isFromCurrentLearner ? "pull-right is-learner" : "pull-left",
          comment.likes > 0 ? "has-likes" : "no-likes",
          comment.isLikedByLearner ? "is-learner-liked" : "",
          comment.isFlaggedByLearner ? "is-learner-flagged" : ""
        ]], [null,true])) + "><div class=\"comment-label clearfix\">");
if ( !comment.isFromCurrentLearner)
{
buf.push("<span class=\"comment-author\">" + (jade.escape(null == (jade_interp = comment.author) ? "" : jade_interp)) + "</span>&ensp;");
}
if ( !peerAuthoring)
{
buf.push("<span" + (jade.attr("data-id", comment.id, true, false)) + " class=\"comment-action comment-like\"><span class=\"icon icon-heart\"></span>&nbsp;" + (jade.escape((jade_interp = comment.likes || 0) == null ? '' : jade_interp)) + "</span>");
}
buf.push("</div>");
if ( !peerAuthoring)
{
buf.push("<div class=\"comment-toggle-action clearfix\">");
if ( comment.isFromCurrentLearner)
{
buf.push("<span" + (jade.attr("data-id", comment.id, true, false)) + " class=\"comment-action comment-delete\">" + (jade.escape(null == (jade_interp = i18n("social.delete")) ? "" : jade_interp)) + "</span><span class=\"comment-action comment-cancel icon icon-close\"></span>");
}
else
{
buf.push("<span" + (jade.attr("data-id", comment.id, true, false)) + " class=\"comment-action comment-flag\"><span class=\"icon icon-flag\"></span>&nbsp;");
if ( comment.isFlaggedByLearner)
{
buf.push(jade.escape(null == (jade_interp = i18n("social.reported")) ? "" : jade_interp));
}
else
{
buf.push(jade.escape(null == (jade_interp = i18n("social.report")) ? "" : jade_interp));
}
buf.push("</span><span class=\"comment-action comment-cancel icon icon-close\"></span>");
}
buf.push("</div>");
}
buf.push("<p class=\"block-md comment-message text-md\">");
if ( isEmoji(comment.message))
{
buf.push("<span class=\"emoji\">" + (jade.escape(null == (jade_interp = comment.message) ? "" : jade_interp)) + "</span>");
}
else
{
buf.push(jade.escape(null == (jade_interp = comment.message) ? "" : jade_interp));
}
buf.push("</p></li>");
    }

  }
}).call(this);

buf.push("</ul>");
if ( !peerAuthoring)
{
if ( isNoMoreComments)
{
buf.push("<p class=\"text-muted text-center block-v-md\">" + (jade.escape(null == (jade_interp = i18n("social.thats-all")) ? "" : jade_interp)) + "</p>");
}
else
{
buf.push("<img src=\"img/templates/loader-light.gif\" width=\"32\" class=\"loader\"/>");
}
}
}}.call(this,"Date" in locals_for_with?locals_for_with.Date:typeof Date!=="undefined"?Date:undefined,"comments" in locals_for_with?locals_for_with.comments:typeof comments!=="undefined"?comments:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"isEmoji" in locals_for_with?locals_for_with.isEmoji:typeof isEmoji!=="undefined"?isEmoji:undefined,"isNoMoreComments" in locals_for_with?locals_for_with.isNoMoreComments:typeof isNoMoreComments!=="undefined"?isNoMoreComments:undefined,"moment" in locals_for_with?locals_for_with.moment:typeof moment!=="undefined"?moment:undefined,"peerAuthoring" in locals_for_with?locals_for_with.peerAuthoring:typeof peerAuthoring!=="undefined"?peerAuthoring:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}